import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";

export async function deleteAccount(request: {
	userId: string;
	tenantId: string;
}) {
	// TODO(backend): derive userId/tenantId from JWT claims; remove body fields once server enforces auth.
	const { data } = await authAxios.post(
		`${API_BASE_URL}/customer/deletion`,
		request,
	);

	return data.data;
}
